// extracted by mini-css-extract-plugin
export var actionButton = "_5y-0";
export var attachmentLine = "_5y-1";
export var fileInput = "_5y-2";
export var fileUploadWrapper = "_5y-4";
export var footer = "_5y-3";
export var modalContent = "_5y-5";
export var paperclip = "_5y-6";
export var quillEditor = "_5y-7";